module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px 0",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏来源",
      "clearable": ""
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, _vm._l((_vm.issued_app_source), function(v, i) {
    return _c('el-option', {
      key: i,
      attrs: {
        "label": v,
        "value": v
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    ref: "input",
    staticClass: "search xs24",
    attrs: {
      "clearable": "",
      "placeholder": "请输入小程序名称",
      "suffix-icon": _vm.pdata.kw.length > 0 ? '' : 'el-icon-search'
    },
    on: {
      "clear": _vm.getList
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event)
      }
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.addProduct
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 1)
      }
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, 0)
      }
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false, -1)
      }
    }
  }, [_vm._v("删除")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-top": "30px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id"
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "width": "80px",
      "min-width": "40px",
      "align": "left"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "游戏名称",
      "width": "250px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "vertical-align": "middle",
            "border-radius": "50%",
            "margin": "0 5px"
          },
          attrs: {
            "src": scope.row.icon,
            "alt": "",
            "width": "32px",
            "height": "32px"
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.editProduct(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source",
      "label": "来源",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "platform",
      "label": "所属平台",
      "min-width": "80px",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.platform), function(item, index) {
          return _c('el-tag', {
            key: item,
            staticStyle: {
              "margin": "0 5px"
            },
            attrs: {
              "type": '',
              "effect": "plain",
              "size": "mini"
            }
          }, [_vm._v("\n\t\t\t\t    " + _vm._s(item) + "\n\t\t\t\t  ")])
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "产品状态",
      "width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": scope.row.status == '1' ? 'success' : 'danger'
          },
          on: {
            "click": function($event) {
              return _vm.changeStatus(true, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status == '1' ? '正常' : '禁用'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '新增产品信息' : '编辑产品信息',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "950px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "小游戏名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "小游戏名称",
      "clearable": ""
    },
    model: {
      value: (_vm.chooseProduct.name),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "name", $$v)
      },
      expression: "chooseProduct.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "曾用名",
      "prop": "rename"
    }
  }, [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "曾用名",
      "clearable": ""
    },
    model: {
      value: (_vm.chooseProduct.rename),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "rename", $$v)
      },
      expression: "chooseProduct.rename"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "游戏图标",
      "prop": "icon"
    }
  }, [_c('UploadImg', {
    attrs: {
      "image": _vm.chooseProduct.icon
    },
    on: {
      "update:image": function($event) {
        _vm.chooseProduct.icon = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "游戏来源"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.chooseProduct.source),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "source", $$v)
      },
      expression: "chooseProduct.source"
    }
  }, _vm._l((_vm.issued_app_source), function(v, i) {
    return _c('el-radio', {
      key: i,
      attrs: {
        "label": v,
        "value": v
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分成公司"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择分成公司名称"
    },
    model: {
      value: (_vm.chooseProduct.cp_company_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "cp_company_id", $$v)
      },
      expression: "chooseProduct.cp_company_id"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "平台标识"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.chooseProduct.platform_id),
      callback: function($$v) {
        _vm.$set(_vm.chooseProduct, "platform_id", $$v)
      },
      expression: "chooseProduct.platform_id"
    }
  }, _vm._l((_vm.get_issued_app_platform), function(v, i) {
    return _c('el-checkbox', {
      key: i + 1,
      attrs: {
        "label": i + 1,
        "value": i + 1
      },
      nativeOn: {
        "click": function($event) {
          _vm.platformChange($event, (i + 1))
        }
      }
    }, [_vm._v(_vm._s(v) + " ")])
  }), 1)], 1), _vm._v(" "), _c('el-tabs', {
    staticStyle: {
      "margin-left": "120px"
    },
    attrs: {
      "type": "card",
      "closable": false
    },
    model: {
      value: (_vm.editableTabsValue),
      callback: function($$v) {
        _vm.editableTabsValue = $$v
      },
      expression: "editableTabsValue"
    }
  }, _vm._l((_vm.editableTabs), function(item, index) {
    return _c('el-tab-pane', {
      key: item.name,
      attrs: {
        "label": item.title,
        "name": item.name
      }
    }, [_c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      attrs: {
        "label": "platform_id"
      }
    }, [_c('el-input', {
      staticClass: "input",
      attrs: {
        "placeholder": "",
        "clearable": "",
        "value": item.name
      },
      model: {
        value: (_vm.platform[item.name - 1].platform_id),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "platform_id", $$v)
        },
        expression: "platform[item.name -1].platform_id"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "小游戏名称"
      }
    }, [_c('el-input', {
      staticClass: "input",
      attrs: {
        "placeholder": "请输入小游戏名称",
        "clearable": ""
      },
      model: {
        value: (_vm.platform[item.name - 1].name),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "name", $$v)
        },
        expression: "platform[item.name -1].name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "小游戏曾用名"
      }
    }, [_c('el-input', {
      staticClass: "input",
      attrs: {
        "placeholder": "请输入小游戏曾用名",
        "clearable": ""
      },
      model: {
        value: (_vm.platform[item.name - 1].rename),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "rename", $$v)
        },
        expression: "platform[item.name -1].rename"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "APPID"
      }
    }, [_c('el-input', {
      staticClass: "input",
      attrs: {
        "placeholder": "请输入小游戏appid",
        "clearable": ""
      },
      model: {
        value: (_vm.platform[item.name - 1].appid),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "appid", $$v)
        },
        expression: "platform[item.name -1].appid"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "APPSECRET"
      }
    }, [_c('el-input', {
      staticClass: "input",
      attrs: {
        "placeholder": "请输入APPSECRET",
        "clearable": ""
      },
      model: {
        value: (_vm.platform[item.name - 1].appsecret),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "appsecret", $$v)
        },
        expression: "platform[item.name -1].appsecret"
      }
    })], 1), _vm._v(" "), (item.name == 1) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "邮箱"
      }
    }, [_c('el-input', {
      staticClass: "input",
      attrs: {
        "placeholder": "请输入邮箱",
        "clearable": ""
      },
      model: {
        value: (_vm.platform[item.name - 1].email),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "email", $$v)
        },
        expression: "platform[item.name -1].email"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "密码"
      }
    }, [_c('el-input', {
      staticClass: "input",
      attrs: {
        "placeholder": "请输入密码",
        "clearable": ""
      },
      model: {
        value: (_vm.platform[item.name - 1].password),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "password", $$v)
        },
        expression: "platform[item.name -1].password"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "主体"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (_vm.platform[item.name - 1].body),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "body", $$v)
        },
        expression: "platform[item.name -1].body"
      }
    }, _vm._l((_vm.app_body), function(v, i) {
      return _c('el-radio', {
        key: i,
        attrs: {
          "label": v,
          "value": v
        }
      })
    }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (item.name == 3) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "账号"
      }
    }, [_c('el-input', {
      staticClass: "input",
      attrs: {
        "placeholder": "请输入邮箱",
        "clearable": ""
      },
      model: {
        value: (_vm.platform[item.name - 1].email),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "email", $$v)
        },
        expression: "platform[item.name -1].email"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "密码"
      }
    }, [_c('el-input', {
      staticClass: "input",
      attrs: {
        "placeholder": "请输入密码",
        "clearable": ""
      },
      model: {
        value: (_vm.platform[item.name - 1].password),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "password", $$v)
        },
        expression: "platform[item.name -1].password"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "分成方式"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (_vm.platform[item.name - 1].divide),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "divide", $$v)
        },
        expression: "platform[item.name -1].divide"
      }
    }, [_c('el-radio', {
      attrs: {
        "label": "原生"
      }
    }, [_vm._v("原生")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "label": "利润"
      }
    }, [_vm._v("利润")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "分成占比",
        "prop": "divide_per"
      }
    }, [_c('el-input', {
      staticClass: "input",
      attrs: {
        "placeholder": "请输入分成占比",
        "clearable": ""
      },
      model: {
        value: (_vm.platform[item.name - 1].divide_per),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "divide_per", $$v)
        },
        expression: "platform[item.name -1].divide_per"
      }
    }), _vm._v("\n\t\t\t\t          \t（给到对方的分成占比,0-1）\n\t\t\t\t\t      ")], 1), _vm._v(" "), (item.name == 1) ? _c('div', [_c('el-form-item', {
      attrs: {
        "label": "小游戏数据采集账号"
      }
    }, [_c('el-radio-group', {
      model: {
        value: (_vm.platform[item.name - 1].game_miniprogram_account),
        callback: function($$v) {
          _vm.$set(_vm.platform[item.name - 1], "game_miniprogram_account", $$v)
        },
        expression: "platform[item.name -1].game_miniprogram_account"
      }
    }, _vm._l((_vm.game_miniprogram_account), function(v, i) {
      return _c('el-radio', {
        key: i,
        attrs: {
          "label": i,
          "value": i
        }
      }, [_vm._v(_vm._s(v))])
    }), 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "小程序码",
        "prop": "qrcode"
      }
    }, [_c('UploadImg', {
      attrs: {
        "image": _vm.platform[item.name - 1].qrcode
      },
      on: {
        "update:image": function($event) {
          _vm.platform[item.name - 1].qrcode = $event
        }
      }
    })], 1)], 1) : _vm._e()], 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-493b114a"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/views/issue/pList.vue
// module id = 561
// module chunks = 0